"use strict";

// References
var alt = require("../alt");
var MessagesActions = require("../actions/MessagesActions");

var messagesStore = alt.createStore(class MessagesStore {
    // Data
    constructor() {
        this.bindActions(MessagesActions);

        this.messages = {};
    }

    // Functions
    onFetchMessages() {
        this.messages = [
            {
                id: 0,
                sender: "Frederick Anderson",
                receiver: "John Austin",
                date: "01.03.15",
                title: "Party on Friday",
                body: "There is a party on Friday John, be there.",
                status: "Unread"
            },
            {
                id: 1,
                sender: "Jonathan Ross",
                receiver: "John Austin",
                date: "03.03.15",
                title: "Sick today",
                body: "I have caught the flu, wont be at work today.",
                status: "Unread"
            }
        ];
    }

});

module.exports = messagesStore;



// WEBPACK FOOTER //
// ./app/scripts/stores/MessagesStore.js